<template>
  <article class="modal_password">
    <section class="modal_password__modal">
      <div class="modal_password__modal__info" >
        <h5 style="margin-bottom:10px;">Conceder permisos</h5>
        <p style="margin-bottom:10px;">Conceder permiso para escuchar transmisión</p>

      </div>

      <div class="modal_password__modal__buttons">
        <button @click="onCancelModal" class="modal_password__modal__buttons--left" style="width: 100% !important;">
          ACEPTAR
        </button>
      </div>

    </section>
  </article>
</template>

<script>
import moment from 'moment'
export default {
 
  data(){
    return{
      fecha:"",
      errorMessage:"",
      Comments: null,
      whoReviews: this.getUserInfo().name+' '+this.getUserInfo().last_name
    }
  },
  methods:{
    onCancelModal(event){      
      this.$emit('cancel', false);
    },
    onActivateModal(event){    
      
      
    }
  }, 
  computed: {
    acceptBtn(){
      return false;
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalPermission.vue